import { useContext } from "react";
import SchoolsDropdownList from "./SchoolsDropdownList";
import { MdArrowDropDown } from "react-icons/md";
import { LoadingDots } from "utils/loadingAnimation";
import { SchoolListType } from "utils/interfaces";
import { ViewHeaderContext } from "components/utils/Contexts";
import { AnimatePresence, motion } from "framer-motion";
import ImageSkeleton from "utils/skeletons/ImageSkeleton";

interface SchoolsDropdownButtonProps {
  showSchoolListTab: boolean;
  schoolData: SchoolListType[];
  contextSchool: SchoolListType | null;
  setContextSchool: React.Dispatch<React.SetStateAction<SchoolListType | null>>;
  setShowSchoolListTab: React.Dispatch<React.SetStateAction<boolean>>;
}

const SchoolsDropdownButton: React.FC<SchoolsDropdownButtonProps> = ({
  showSchoolListTab,
  schoolData,
  contextSchool,
  setContextSchool,
  setShowSchoolListTab,
}) => {
  // Get the panel width
  const { format } = useContext(ViewHeaderContext);

  return (
    <div className="relative">
      <motion.div
        variants={{
          shrinked: { width: "fit-content", minWidth: "fit-content" },
          expanded: { width: 250 },
        }}
        initial={false}
        animate={format}
        transition={{ ease: "easeInOut" }}
        tabIndex={0}
        className={`max-w-[250px] w-[250px] self-stretch grow shrink px-3 py-1 bg-white rounded-full justify-between text-start items-center gap-2 flex ${
          showSchoolListTab ? "" : "cursor-pointer"
        } relative`}
        onClick={() => setShowSchoolListTab(!showSchoolListTab)}
      >
        <div className="w-6 h-6 min-w-6 rounded-full border border-Subtle justify-start items-end gap-2 flex overflow-hidden">
          <ImageSkeleton
            src={`/api/imgs/organisations/logo/${
              contextSchool ? contextSchool._id : ""
            }`}
            alt={`school-logo${contextSchool ? "-" + contextSchool._id : ""}`}
            className="w-full h-full select-none relative"
          />
        </div>
        <AnimatePresence mode="popLayout">
          {format === "expanded" && (
            <motion.div
              key="expanded"
              initial={{ opacity: 0, width: 0 }}
              animate={{ opacity: 1, width: "100%" }}
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: 0.3, ease: "linear" }}
              className="max-w-[180px] inline-flex justify-center text-neutral-500 text-sm text-center font-semibold font-poppins leading-[17px] overflow-hidden break-keep whitespace-nowrap text-ellipsis select-none"
            >
              {contextSchool && contextSchool.name ? (
                contextSchool.name
              ) : (
                <LoadingDots bgColor="bg-neutral-500" />
              )}
            </motion.div>
          )}
        </AnimatePresence>
        <motion.div
          initial={{ rotate: 0 }}
          animate={{ rotate: showSchoolListTab ? -180 : 0 }}
          className="w-4 h-4 relative"
        >
          <MdArrowDropDown className="w-full h-full fill-neutral-700" />
        </motion.div>
      </motion.div>
      {/* List of schools */}
      <AnimatePresence>
        {showSchoolListTab && (
          <SchoolsDropdownList
            schoolData={schoolData}
            setShowSchoolListTab={setShowSchoolListTab}
            setContextSchool={setContextSchool}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default SchoolsDropdownButton;
